import { CapoPlugin } from "/codebuild/output/src3758341090/src/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];